import { init as initListing } from '../listing/listing.js';

// Reprise du style des listings
import '../listing/listing.css';
import '../modal/modal.css';

import './etude-listing.css';

initListing('.etudes-du-jour');
initListing('.etudes-listing');
